// extracted by mini-css-extract-plugin
export default {"text":"OutlineText_text__K5uTv","face":"OutlineText_face__mh0Bo"};